<template>
  <div class="page-container">
    <div class="main-left">
      <div class="top-content">

        <div class="filter-wrapper">
          <div class="title">
            <div style="display:flex;align-items:center; justify-content:flex-start;">
              <i class="title-icon iconfont icon-duilie"></i>
              <span class="title-label">队列列表</span>
            </div>
            <button class="btn btn_newpatient" @click="handleNewCohort" style="margin-right:5px;">新建</button>
          </div>
          <div class="content">
            <!-- 搜索栏 -->
            <div class="cohort-list-toolbar">
              <el-input v-model="listKeyword" size="mini" prefix-icon="el-icon-search" placeholder="搜索队列名称..." clearable style="width:160px;" @change="handleSearchCohorts"></el-input>
            </div>
            <!-- 列表 -->
            <el-table :data="cohortList" v-loading="cohortListLoading" size="mini" stripe style="width:100%;" @row-dblclick="handleLoadCohort" :row-class-name="({row}) => row.id === currentCohortId ? 'cohort-row-selected' : ''">
              <el-table-column prop="name" label="队列名称" min-width="100" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <span class="cohort-name-link" @click.stop="handleLoadCohort(row)">{{ row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="patient_count" label="人数" width="55" align="center"></el-table-column>
              <el-table-column prop="status" label="状态" width="65" align="center">
                <template slot-scope="{ row }">
                  <el-tag :type="row.status === 'FROZEN' ? 'info' : 'success'" size="mini" effect="plain">{{ row.status === 'FROZEN' ? '冻结' : '活跃' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="110" align="center">
                <template slot-scope="{ row }">
                  <el-button type="text" size="mini" @click.stop="handleToggleFreeze(row)" :title="row.status === 'FROZEN' ? '解冻' : '冻结'">
                    <i :class="row.status === 'FROZEN' ? 'el-icon-unlock' : 'el-icon-lock'"></i>
                  </el-button>
                  <el-dropdown trigger="click" @command="(cmd) => handleCohortCommand(cmd, row)">
                    <el-button type="text" size="mini"><i class="el-icon-more"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="clone"><i class="el-icon-document-copy"></i> 克隆</el-dropdown-item>
                      <el-dropdown-item command="delete" divided><i class="el-icon-delete" style="color:#F56C6C;"></i> <span style="color:#F56C6C;">删除</span></el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="cohort-list-pagination" v-if="cohortListTotal > cohortListPageSize">
              <el-pagination small layout="prev, pager, next" :total="cohortListTotal" :page-size="cohortListPageSize" :current-page="cohortListPage" @current-change="handleCohortListPageChange"></el-pagination>
            </div>
          </div>
        </div>

      </div>
      <div class="bottom-content">
        <div class="diagnosis-form-wrapper">
          <div class="title">
            <div style="display: flex;align-items: center;">
              <i class="title-icon iconfont icon-iconset0123"></i>
              <span class="title-label">队列详情</span>
            </div>
          </div>
          <div class="content">
            <div v-if="!currentCohortId" class="cohort-detail-empty">
              <i class="el-icon-info" style="font-size:20px;color:#c0c4cc;"></i>
              <p style="color:#909399;margin:4px 0 0;font-size:13px;">请在左侧列表中选择一个队列</p>
            </div>
            <div v-else class="cohort-detail-info">
              <div class="cohort-detail-row">
                <span class="cohort-detail-label">队列名称</span>
                <span class="cohort-detail-value">{{ cohortName }}</span>
              </div>
              <div class="cohort-detail-row">
                <span class="cohort-detail-label">状态</span>
                <el-tag :type="cohortStatus === 'FROZEN' ? 'info' : 'success'" size="mini" effect="plain">{{ cohortStatus === 'FROZEN' ? '冻结' : '活跃' }}</el-tag>
              </div>
              <div class="cohort-detail-row">
                <span class="cohort-detail-label">患者人数</span>
                <span class="cohort-detail-value">{{ cohortPatientCount }}</span>
              </div>
              <div class="cohort-detail-row" v-if="cohortDescription">
                <span class="cohort-detail-label">描述</span>
                <span class="cohort-detail-value cohort-detail-desc">{{ cohortDescription }}</span>
              </div>
              <div class="cohort-detail-row" v-if="cohortCreateTime">
                <span class="cohort-detail-label">创建时间</span>
                <span class="cohort-detail-value">{{ cohortCreateTime }}</span>
              </div>
              <div class="cohort-detail-row" v-if="cohortUpdateTime">
                <span class="cohort-detail-label">更新时间</span>
                <span class="cohort-detail-value">{{ cohortUpdateTime }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-center">
      <div class="top-content">
        <div
          class="cohort-wrapper"
          v-loading="isPreviewLoading"
          element-loading-text="正在试算"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.2)"
        >
          <div class="head">
            <div style="display:flex;align-items:center;">
              <i style="font-size:1.5rem;margin-right:10px;" class="iconfont icon-shaixuan"></i>
              <span id="fontF">多维筛选器</span>
              <el-select v-model="currentDisease" size="mini" style="margin-left:15px;width:120px;" @change="onDiseaseChange">
                <el-option label="黑色素瘤" value="MELANOMA"></el-option>
                <el-option label="白癜风" value="VITILIGO" disabled></el-option>
              </el-select>
              <div class="preview-count" v-if="queryTree.children.length > 0">
                符合条件: <b>{{ previewCount }}</b> 人
                <el-button v-if="previewCount > 0" type="text" size="mini" class="preview-view-btn" @click="handlePreviewViewResult">查看筛选结果</el-button>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="filter-container">
              <div class="field-dictionary">
                <el-input v-model="dictSearchKeyword" size="mini" prefix-icon="el-icon-search" placeholder="搜索指标..." clearable style="margin-bottom:8px;"></el-input>
                <div class="dict-groups">
                  <div v-for="group in filteredDictGroups" :key="group.key" class="dict-group">
                    <div class="dict-group-title"><i class="el-icon-folder-opened"></i> {{ group.label }}</div>
                    <div v-for="field in group.fields" :key="field.key" class="dict-field-item" @click="addConditionFromDict(field.key)">
                      <i class="el-icon-document"></i> {{ field.label }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="query-builder">
                <div class="query-builder-empty" v-if="queryTree.children.length === 0">
                  <i class="el-icon-plus" style="font-size:24px;color:#c0c4cc;"></i>
                  <p style="color:#909399;margin:4px 0 0;font-size:13px;">点击左侧指标添加筛选条件</p>
                </div>
                <cohort-filter-group
                  v-else
                  :group="queryTree"
                  :depth="0"
                  :parentGroup="null"
                  :index="-1"
                  :diseaseDict="currentDict"
                  @add-condition="addCondition"
                  @add-group="addGroup"
                  @remove-node="removeNode"
                  @field-change="onFieldChange"
                  @operator-change="onOperatorChange"
                ></cohort-filter-group>
                <div class="filter-actions" v-if="queryTree.children.length > 0">
                  <el-button size="small" type="primary" icon="el-icon-check" @click="handleSaveCohort(false)">{{ currentCohortId ? '更新队列' : '新建队列' }}</el-button>
                  <el-button size="small" icon="el-icon-document-copy" @click="handleSaveCohort(true)" v-if="currentCohortId">另存为新队列</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="bottom-content">
        <div class="patient-list-wrapper">
          <div class="head">
            <div style="display:flex;align-items:center;">
              <i style="font-size:1.5rem;margin-right:10px;" class="iconfont icon-bijibennotebook43"></i>
              <span id="fontF">患者列表</span>
            </div>
            <!-- <div class="btn-wrap" >
              <button class="btn" style="font-size: 14px;">XXXX</button>
            </div> -->
          </div>
          <!-- <div class="quickSearch"> 
            <div class="quickSearchLine"> 
              <div style="margin:10px 10px 10px 20px; width:100px; font-size:14px; font-weight:600" class="mirrorText" id="fontM">快捷输入
                <el-popover
                  placement="top-start"
                  title="帮助"
                  width="240"
                  trigger="hover"
                  content="可以输入治疗设备、方法、模块、药物等文字、拼音、拼音首字母等，快捷检索项目信息"
                >
                  <i slot="reference" class="iconfont icon-bangzhu popTips"></i>
                </el-popover>
              </div>
              <el-autocomplete
                id="diagnose-result-input"
                class="inline-input"
                v-model="quickSelectedItem"
                :fetch-suggestions="queryItem"
                clearable
                placeholder="----输入文字、拼音、拼音首字母等----"
                :trigger-on-focus="false"
                @select="selectItem"
                @blur="saveQuickSelection(false, '', 'yes')"
                @focus="haveSelectedItem = false"
                size="small"
                style="width: 80%;"
              ></el-autocomplete>
            </div>           
          </div> -->

       
          <div class="content" style="height: 100%; display: flex;flex-direction:column;justify-content: space-between;padding: 0;">
            
              <!-- <div class="header">
                <span style="margin-right:10px;margin-left:15px;font-size:18px;font-weight:bold;"><h2>筛选词:</h2></span>
                <span style="margin-right:10px;margin-left:15px;">诊疗类型:</span>
                <el-select clearable style="width: 115px"  @change="searchName" v-model="diagnosis_type"
                            placeholder="请选择">
                  <el-option
                    v-for="item in diagnosisTypeList"
                    :key="item.key"
                    :label="item.val"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>

                <span style="margin-right:10px; margin-left:10px;">   患者信息:</span>
                <el-input
                  style="width:200px;margin-right:20px"
                  placeholder="ID/姓名/手机号"
                  prefix-icon="el-icon-search"
                  v-model="keywordString"
                  clearable
                  @change="searchName"
                ></el-input>
                <span style="margin-right:10px;">年龄:</span>
                <el-input
                  placeholder="从"
                  v-model="startAge"
                  style="width:80px;margin-right:20px;"
                  @change="searchName"
                  clearable
                ></el-input>
                <span style="margin-right:20px;">-</span>
                <el-input
                  placeholder="至"
                  v-model="endAge"
                  style="width:80px;margin-right:20px;"
                  @change="searchName"
                  clearable
                ></el-input>
                
                <span style="margin-right:10px;">患者创建时间:</span>
                <el-date-picker
                  style="margin-right: 20px;width: 21%"
                  v-model="sDate"
                  clearable
                  type="datetimerange"
                  range-separator="至"
                  @change="searchName"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
                

                
                <div class="space"></div>
                <button
                  class="btn iconfont createPatients"
                  style="padding: 0; margin-right:10px; width:80px"                
                  @click.prevent="searchName"
                >刷    新</button>
              </div> -->
              <!-- 数据加载提示 -->
              <div style="height: 100%" 
                v-loading="getPatientListLoading"
                element-loading-text="数据加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.4)"
              >
              <ul class="patient-list">
                <li class="list-header">
                  <div style="display: flex;flex: 1">
                    <span style="width:4%">序号</span>
                    <!-- <span style="width:8%">历史诊断</span> -->
                    <span style="width:8%" class="tableTitle" @click="order('id')">
                      ID
                      <!-- <i class="iconfont icon-paixu1"></i> -->
                    </span>
                    <span style="width:9%" class="tableTitle" @click="order('name')">
                      姓名
                      <!-- <i class="iconfont icon-paixu1"></i> -->
                    </span>
                    <span style="width:4%">性别</span>
                    <span style="width:5%">年龄</span>
                    <!-- <span style="width:10%">民族</span> -->
                    <span style="width:10%" class="tableTitle" @click="order('update_time')">
                      更新时间
                      <!-- <i class="iconfont icon-paixu1"></i> -->
                    </span>
                    <span style="width:10%" class="tableTitle" @click="order('created_time')">
                      患者创建时间
                      <!-- <i class="iconfont icon-paixu1"></i> -->
                    </span>

                    <span style="width:12%" class="tableTitle" @click="">
                      最新诊断
                    </span>
                    <span style="width:45%">
                      诊疗记录
                    </span>
                  </div>
                  <!-- <span style="width: 26px"></span> -->
                </li>
                <!-- @change="changeHandler" -->
                <!-- @cell-click='changeHandler(row, column, cell, event)' -->
                <el-collapse @change="changeHandler" v-model="activeName" accordion>
                  <el-collapse-item v-for="(item,index) in patients" :key="index" :name="item.id">
                    <template slot="title">
                      <li style="width:100%" class="list-content">
                        <div class="list-item">
                          <span style="width:4%">{{index+1}}</span>
                          <!-- <span style="width:8%;font-size:24px" @click="showHid(index,item.id)">
                                  <i class="el-icon-tickets"></i>
                          </span>-->
                          <span
                            style="width:8%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding:0 10px;box-sizing: border-box"
                          >{{item.id_in_hospital ? item.id_in_hospital : item.id}}</span>
                          <span
                            style="width:9%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding:0 10px;box-sizing: border-box"
                          >{{item.name}}</span>
                          <span style="width:4%">{{item.gender}}</span>
                          <span style="width:4%">{{item.showAge}}</span>
                          <!-- <span style="width:10%">{{item.race}}</span> -->
                          <!-- <span
                            style="width:20%"
                            v-if="item.last_diagnosis"
                          >{{item.last_diagnosis.time | formatTime}}</span>-->
                          <span style="width:10%">{{item.update_time}}</span>
                          <span style="width:10%">{{item.created_time}}</span>
                          <span
                            style="width:12%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding:0 10px;
                            box-sizing: border-box">{{item.last_diagnosis_text}}
                          </span>

                          <span style="width:40%;z-index:999">                         
                            <el-button
                              v-acl="['diagnoses_image']"
                              size="mini"
                              type="primary"
                              class="btn btn-white"
                              style="width: 46px;display:inline-block;"
                            >影像<el-badge is-dot type="warning" v-show="item.diagnosesNum.diagnoses>0"></el-badge>
                            </el-button>
                            
                            <el-button
                              v-acl="['operation_order']"
                              size="mini"
                              type="primary"
                              class="btn btn-white"
                              style="width: 46px;display:inline-block;"
                            >手术<el-badge is-dot type="warning" v-show="item.diagnosesNum.operation>0"></el-badge>
                            </el-button>
                            <el-button
                              v-acl="['inhospital_order']"
                              size="mini"
                              type="primary"
                              class="btn btn-white"
                              style="width: 46px;display:inline-block;"
                            >住院<el-badge is-dot type="warning" v-show="item.diagnosesNum.inHospital>0"></el-badge>
                            </el-button>
                            <el-button
                              v-acl="['export_cosmetology']"
                              size="mini"
                              type="primary"
                              class="btn btn-white"
                              style="width: 66px;display:inline-block;"
                            >美容/治疗<el-badge is-dot type="warning"  v-show="item.diagnosesNum.cosmetology>0"></el-badge>
                            </el-button>
                            <el-button
                              v-acl="['sd_vitiligo']"
                              size="mini"
                              type="primary"
                              class="btn btn-white"
                              style="width: 54px;display:inline-block;"
                            >白癜风<el-badge is-dot type="warning"  v-show="item.diagnosesNum.vitiligoBasicInfo>0"></el-badge>
                            </el-button>
                            <el-button
                              v-acl="['sd_mm']"
                              size="mini"
                              type="primary"
                              class="btn btn-white"
                              style="width: 54px;display:inline-block;"
                            >黑素瘤<el-badge is-dot type="warning"  v-show="item.diagnosesNum.mmBasicInfo>0"></el-badge>
                            </el-button>
                            <el-button
                              @click.stop="showRevise($event,item.id)"
                              size="mini"
                              type="primary"
                              icon="el-icon-edit"
                              class="btn btn-white"
                              style="width: 82px;display:inline-block; "
                            > 患者详情</el-button>
                          </span>
                        </div>
                      </li>
                    </template>
                    <div class="list-hid" v-if="resultArr.length>0">
                      <div ref="mySwiper" class="firstShow">
                        <div
                          v-for="(ele,index2) in resultArr[0]"
                          :key="index2"
                          class="check-box"
                          :style="{'background':background(ele.typeDignoses)}"
                        >
                          <span class="card-type-badge" :style="{'background':typeBadgeColor(ele.typeDignoses)}">{{typeBadge(ele.typeDignoses)}}</span>
                          <div
                            @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                            v-if="ele.typeDignoses=='影像'"
                            class="check-box2"
                          >
                            <div class="imgBack cardImg">
                              <template v-if="ele.images.length > 0">
                                <img
                                  :src="imageSrcPrefixThumbnails +ele.images[0].path"
                                  alt
                                  class="checkBoxImg"
                                  :class="{'heightAuto':ele.images[0].width<ele.images[0].height,'widthAuto':ele.images[0].width>=ele.images[0].height}"
                                />
                              </template>
                            </div>
                            <div class="check-info">
                              <p>
                                检查时间:
                                <span>{{ele.time}}</span>
                              </p>
                              <p style="display: flex;justify-content: space-between">
                                <span class="ellipsis" style="flex: 1;color: rgb(74,163,196);text-align: left">
                                  检查编号:
                                  <span>{{ele.id_in_hospital}}</span>
                                </span>
                                <span
                                  class="iconfont"
                                  style="color: rgb(255,68,0);cursor: default"
                                  v-if="ele.isPrintReport"
                                  title="未打印报告"
                                  @click.stop=""
                                >&#xe62b;</span>
                              </p>
                              
                              <p class="ellipsisP">
                                检查部位:
                                <span class="ellipsisSpan ellipsis">{{ele.position_detail_list}}</span>
                              </p>
                              <template v-if="ele.doctor_conclusion">
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p class="ellipsisP">
                                    结果:
                                    <span
                                      class="ellipsis ellipsisSpan"
                                    >{{ele.doctor_conclusion | formatConclusion}}</span>
                                  </p>
                                  <div
                                    class="iconfont modify-btn"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑诊断"
                                    v-acl="['diagnoses_image']"
                                    @click.stop="modifyDiagnosis(ele.id)"
                                    v-if="isShowModifyDiagnosisBtn(ele.time) && ele.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont"
                                    v-acl="['diagnoses_image']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    v-else
                                    @click.stop
                                  >&#xe630e;</div>
                                  <div class="iconfont" v-acl="['gen_online_report']" @click.stop="showOnlineReport(ele.id)">  
                                    <img src="../assets/online_report.png" style="width: 17px;height:15px;margin-left:15px;margin-top:2px" />
                                  </div>
                                  

                                </div>
                              </template>
                              <template v-else>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p>
                                    结果:
                                    <span></span>
                                  </p>
                                  <!-- <div
                                    v-acl="['diagnoses_image']"
                                    class="iconfont modify-btn"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑诊断"
                                    @click.stop="modifyDiagnosis(ele.id)"
                                    v-if="isShowModifyDiagnosisBtn(ele.time) && ele.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont"
                                    v-acl="['diagnoses_image']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    v-else
                                    @click.stop
                                  >&#xe630e;</div> -->

                                  
                                </div>
                              </template>
                            </div>
                          </div>
                          <div
                            @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                            v-if="ele.typeDignoses=='美容'"
                            class="check-box2"
                          >
                            <div class="imgBack cardImg">
                              <template v-if="ele.image_cosmetology.length > 0">
                                <img
                                  :src="imageSrcPrefixThumbnails2 +ele.image_cosmetology[0].path"
                                  alt
                                  class="checkBoxImg"
                                  :class="{'heightAuto':ele.image_cosmetology[0].width<ele.image_cosmetology[0].height,'widthAuto':ele.image_cosmetology[0].width>=ele.image_cosmetology[0].height}"
                                />
                              </template>
                            </div>
                            <div class="check-info">
                              <p
                                style="display: flex;justify-content: space-between"
                                :title="ele.title"
                              >
                                <span class="cosmetology">
                                  项目:
                                  <span>{{ele.title}}</span>
                                </span>
                              </p>
                              <p class="cosmetology">
                                创建时间:
                                <span>{{ele.time}}</span>
                              </p>
                              <p class="ellipsisP cosmetology">
                                次数:
                                <span
                                  class="ellipsisSpan ellipsis"
                                >第{{ele.leftNum}}次/共{{ele.total}}次</span>
                              </p>
                              <template v-if="true">
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p class="ellipsisP cosmetology">
                                    备注:
                                    <span class="ellipsis ellipsisSpan">{{ele.remarks}}</span>
                                  </p>
                                  <!-- <div
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑美容"
                                    v-acl="['export_cosmetology']"
                                    @click.stop="modifyCosmetology(ele)"
                                    v-if="ele.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    v-acl="['export_cosmetology']"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div> -->
                                </div>
                              </template>
                              <!-- <template v-else>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p>
                                    结果:
                                    <span></span>
                                  </p>
                                  <div
                                  v-acl="['diagnoses_image']"
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑诊断"
                                    @click.stop="modifyDiagnosis(ele)"
                                    v-if="isShowModifyDiagnosisBtn(ele.time)"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont" v-acl="['diagnoses_image']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    v-else
                                    @click.stop=""
                                  >&#xe630e;</div>
                                </div>
                              </template>-->
                            </div>
                          </div>
                          <div
                            @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                            class="check-box2 inHospitalCard"
                            v-if="ele.typeDignoses=='住院'"
                          >
                            <div class="imgBack cardImg">
                              <template v-if="ele.image_hospitalization.length > 0">
                                <img
                                  :src="hospitalization_imagesThumbnails
                              +ele.image_hospitalization[ele.image_hospitalization.length - 1].path"
                                  alt
                                  class="checkBoxImg"
                                  :class="{'heightAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width<ele.image_hospitalization[ele.image_hospitalization.length - 1].height,'widthAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width>=ele.image_hospitalization[ele.image_hospitalization.length - 1].height}"
                                />
                              </template>
                            </div>
                            <div class="check-info">
                              <p>
                                记录时间:
                                <span>{{ele.update_time}}</span>
                              </p>
                              <p>
                                病程及诊断:  
                                <span>{{ele.disease_course}};</span>                            
                                <span>{{ele.diagnosis | formatConclusion}}</span>                              
                              </p>     
                              <p class="ellipsisP">
                                病情:
                                <span class="ellipsis ellipsisSpan">{{ele.curative_effect}}</span>
                              </p>                      
                              <!-- <p>
                                入院时间:
                                <span>{{ele.inpat_date}}</span>
                              </p> -->
                              <!-- <p>
                                出院时间:
                                <span>{{ele.outpat_date}}</span>
                              </p> -->
                              <!-- <p class="ellipsisP">
                                诊断:
                                <span
                                  class="ellipsisSpan ellipsis"
                                >{{ele.diagnosis | formatConclusion}}</span>
                              </p> -->
                              <template>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p class="ellipsisP">
                                    备注:
                                    <span class="ellipsis ellipsisSpan">{{ele.remarks}}</span>
                                  </p>
                                  <!-- <div
                                    class="iconfont"
                                    v-acl="['inhospital_order']"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑住院信息"
                                    @click.stop="getInHospital(ele.id,item)"
                                    v-if="ele.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont"
                                    v-acl="['inhospital_order']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div> -->
                                </div>
                              </template>
                            </div>
                          </div>
                          <div
                            @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                            v-if="ele.typeDignoses=='手术'"
                            class="check-box2 operation"
                          >
                            <div
                              class="imgBack cardImg"
                              :style="`background-image: url(${operationDoctor})`"
                              style="background-size: contain;background-position: center center;background-repeat:  no-repeat;background-color: rgb(246,246,246)"
                            ></div>
                            <div class="check-info">
                              <p>
                                手术时间:
                                <span>{{ele.operation_date | formatTime1}}</span>
                              </p>
                              <p>
                                手术名称:
                                <span>{{ele.operation_name}}</span>
                              </p>
                              <p class="ellipsisP">
                                手术部位:
                                <span
                                  class="ellipsisSpan ellipsis"
                                >&nbsp{{ele.operation_position}}</span>
                              </p>
                              <template v-if="ele.doctor_conclusion">
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p class="ellipsisP">
                                    手术医生:
                                    <span
                                      class="ellipsis ellipsisSpan"
                                    >&nbsp{{ele.operation_doctor}}</span>
                                  </p>
                                  <div
                                    v-acl="['operation_order']"
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑手术信息"
                                    @click.stop="getOperationl(ele,item)"
                                    v-if="ele.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    v-acl="['operation_order']"
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="编辑手术信息"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div>
                                </div>
                              </template>
                              <template v-else>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p>
                                    诊断结果:
                                    <span
                                      :title="ele.relevant_info[0].diagnosis | formatConclusion"
                                    >{{ele.relevant_info[0].diagnosis | formatConclusion}}</span>
                                  </p>
                                  <!-- <div
                                    v-acl="['operation_order']"
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑手术信息"
                                    @click.stop="getOperationl(ele,item)"
                                    v-if="ele.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    v-acl="['operation_order']"
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="编辑手术信息"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div> -->
                                </div>
                              </template>
                            </div>
                          </div>

                          <div
                            @click="getInfo(ele.id,item.id,ele.typeDignoses)"
                            class="check-box2 inHospitalCard"
                            v-if="ele.typeDignoses=='白癜风基础'"
                          >
                            <div class="imgBack cardImg">
                              <!-- <template v-if="ele.image_hospitalization.length > 0">
                                <img
                                  :src="hospitalization_imagesThumbnails
                              +ele.image_hospitalization[ele.image_hospitalization.length - 1].path"
                                  alt
                                  class="checkBoxImg"
                                  :class="{'heightAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width<ele.image_hospitalization[ele.image_hospitalization.length - 1].height,'widthAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width>=ele.image_hospitalization[ele.image_hospitalization.length - 1].height}"
                                />
                              </template> -->
                            </div>
                            <div class="check-info">
                              <p>
                                记录时间:
                                <span> {{ele.visit_date}}</span>
                              </p>
                              <p>
                                类型及病程:  
                                <span> {{ele.vitiligo_type}};</span>                            
                                <span >{{(ele.duration_months&&ele.duration_months>0)?ele.duration_months+'月':'无'}}</span>                              
                              </p>     
                              <p class="ellipsisP">
                                现部位:
                                <span class="ellipsis ellipsisSpan"> {{ele.current_location}}</span>
                              </p>                      
                              <p class="ellipsisP">
                                BAS评分:
                                <span> {{ele.bsa_score}}</span>
                              </p>

                              <!-- <p class="ellipsisP">
                                诊断:
                                <span
                                  class="ellipsisSpan ellipsis"
                                >{{ele.diagnosis | formatConclusion}}</span>
                              </p> -->
                              <template>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <!-- <p class="ellipsisP">
                                    备注:
                                    <span class="ellipsis ellipsisSpan">{{ele.remark1}}|{{ele.remark2}}|{{ele.remark3}}</span>
                                  </p> -->
                                  <p class="ellipsisP">
                                    用药:
                                    <span> {{ele.topical_medication}}</span>
                                  </p>
                                  <div
                                    class="iconfont"
                                    v-acl="['sd_vitiligo']"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑信息"
                                    @click.stop="getVitiligo(ele.id,item)"
                                    v-if="ele.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont"
                                    v-acl="['sd_vitiligo']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div>
                                </div>
                              </template>
                            </div>
                          </div>

                          <div
                            
                            class="check-box2 inHospitalCard"
                            v-if="ele.typeDignoses=='黑色素瘤'"
                          >
                            <!-- @click="getInfo(ele.id,item.id,ele.typeDignoses)" -->
                            <div class="imgBack cardImg">
                            </div>
                            <div class="check-info">
                              <p>
                                记录时间:
                                <span> {{ele.visit_date}}</span>
                                <span v-if="ele.baseline===1" class="baseline-badge">基线</span>
                              </p>
                              <p class="ellipsisP">
                                原发部位:
                                <span class="ellipsis ellipsisSpan"> {{ele.primary_site}}</span>
                              </p>
                              <p class="ellipsisP">
                                AJCC8分期:
                                <span> {{ele.ajcc8_clinical_stage}}</span>
                              </p>
                              <p class="ellipsisP">
                                手术方式:
                                <span class="ellipsis ellipsisSpan"> {{ele.method_of_first_surgery}}</span>
                              </p>
                              <template>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: flex-end"
                                >
                                  <!-- v-if="ele.isedit === 1" 此处点击总是进入对话框，但是会根据isedit状态判断是否可编辑-->
                                  <div
                                    class="iconfont"
                                    v-acl="['sd_mm']"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                    title="编辑信息"
                                    @click.stop="getMm(ele.id, ele.isedit===1, item)"
                                  >&#xe630e;</div>
                                  <!-- <div
                                    class="iconfont"
                                    v-acl="['sd_mm']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div> -->
                                </div>
                              </template>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div v-if="!showall" class="getMore" @click="showAll">显示全部</div>
                      <div v-if="showall" class="moreShow">
                        <div v-for="(ele,index2) in moreResultArr" :key="index2" class="moreItem">
                          <div
                            v-for="(innerItem, index) in ele"
                            :key="index"
                            class="check-box"
                            :style="{'background':background(innerItem.typeDignoses)}"
                          >
                            <span class="card-type-badge" :style="{'background':typeBadgeColor(innerItem.typeDignoses)}">{{typeBadge(innerItem.typeDignoses)}}</span>
                            <div
                              v-if="innerItem.typeDignoses=='影像'"
                              class="check-box2"
                              @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                            >
                              <div class="imgBack cardImg">
                                <template v-if="innerItem.images.length > 0">
                                  <template v-for="(imgItem, imgIndex) in innerItem.images">
                                    <img
                                      :src="imageSrcPrefixThumbnails + imgItem.path"
                                      :key="imgIndex"
                                      v-if="imgIndex === 0"
                                      alt
                                      class="checkBoxImg"
                                      :class="{'heightAuto': imgItem.width<imgItem.height,'widthAuto': imgItem.width>=imgItem.height}"
                                    />
                                  </template>
                                </template>
                              </div>
                              <div class="check-info">
                                <p>
                                  检查时间:
                                  <span>{{innerItem.time}}</span>
                                </p>
                                <p style="display: flex;justify-content: space-between">
                                  <span class="ellipsis" style="flex: 1;color: rgb(74,163,196);text-align: left">
                                    检查编号:
                                    <span>{{innerItem.id_in_hospital}}</span>
                                  </span>
                                  <span
                                    class="iconfont"
                                    style="color: rgb(255,68,0);cursor: default"
                                    v-if="innerItem.isPrintReport"
                                    title="未打印报告"
                                    @click.stop=""
                                  >&#xe62b;</span>
                                </p>

                                <p class="ellipsisP">
                                  检查部位:
                                  <span
                                    class="ellipsisSpan ellipsis"
                                  >{{innerItem.position_overview_list}}-{{innerItem.position_detail_list}}</span>
                                </p>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p class="ellipsisP">
                                    结果:
                                    <span
                                      v-if="innerItem.doctor_conclusion"
                                      class="ellipsis ellipsisSpan"
                                    >{{innerItem.doctor_conclusion | formatConclusion}}</span>
                                  </p>
                                  <!-- <div
                                    class="iconfont"
                                    v-acl="['diagnoses_image']"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight:bold"
                                    title="编辑诊断"
                                    @click.stop="modifyDiagnosis(innerItem.id)"
                                    v-if="isShowModifyDiagnosisBtn(innerItem.time) && innerItem.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont"
                                    v-acl="['diagnoses_image']"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    v-else
                                    @click.stop
                                  >&#xe630e;</div> -->
                                  <!-- <div class="iconfont" v-acl="['gen_online_report']" @click.stop="showOnlineReport(ele.id)">  
                                    <img src="../assets/online_report.png" style="width: 17px;height:15px;margin-left:15px;margin-top:2px" />
                                  </div> -->
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="innerItem.typeDignoses=='美容'"
                              class="check-box2"
                              @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                            >
                              <div class="imgBack cardImg">
                                <template v-if="innerItem.image_cosmetology.length > 0">
                                  <template
                                    v-for="(imgItem, imgIndex) in innerItem.image_cosmetology"
                                  >
                                    <img
                                      :src="imageSrcPrefixThumbnails2 + imgItem.path"
                                      :key="imgIndex"
                                      v-if="imgIndex === 0"
                                      alt
                                      class="checkBoxImg"
                                      :class="{'heightAuto': imgItem.width<imgItem.height,'widthAuto': imgItem.width>=imgItem.height}"
                                    />
                                  </template>
                                </template>
                              </div>
                              <div class="check-info">
                                <p
                                  style="display: flex;justify-content: space-between"
                                  :title="innerItem.title"
                                >
                                  <span class="cosmetology">
                                    项目:
                                    <span>{{innerItem.title}}</span>
                                  </span>
                                </p>
                                <p class="cosmetology">
                                  创建时间:
                                  <span>{{innerItem.time}}</span>
                                </p>
                                <p class="ellipsisP cosmetology">
                                  次数:
                                  <span
                                    class="ellipsisSpan ellipsis"
                                  >第{{innerItem.leftNum}}次/共{{innerItem.total}}次</span>
                                </p>
                                <div
                                  style="display: flex;align-items: flex-end;justify-content: space-between"
                                >
                                  <p class="ellipsisP cosmetology">
                                    备注:
                                    <span class="ellipsis ellipsisSpan">{{innerItem.remarks}}</span>
                                  </p>
                                  <!-- <div
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #f40;font-weight:bold"
                                    title="编辑美容"
                                    v-acl="['export_cosmetology']"
                                    @click.stop="modifyCosmetology(innerItem)"
                                    v-if="innerItem.isedit === 1"
                                  >&#xe630e;</div>
                                  <div
                                    class="iconfont"
                                    style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                    title="不可编辑"
                                    v-acl="['export_cosmetology']"
                                    @click.stop=""
                                    v-else
                                  >&#xe630e;</div> -->
                                </div>
                              </div>
                            </div>
                            <div
                              @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                              class="check-box2 inHospitalCard"
                              v-if="innerItem.typeDignoses=='住院'"
                            >
                              <div class="imgBack cardImg">
                                <template v-if="innerItem.image_hospitalization.length > 0">
                                  <img
                                    :src="hospitalization_imagesThumbnails
                              +innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].path"
                                    alt
                                    class="checkBoxImg"
                                    :class="{'heightAuto':innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].width<innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].height,'widthAuto':innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].width>=innerItem.image_hospitalization[innerItem.image_hospitalization.length - 1].height}"
                                  />
                                </template>
                              </div>
                              <div class="check-info">

                                <p>
                                  记录时间:
                                  <span>{{innerItem.update_time}}</span>
                                </p>
                                <p>
                                  病程及诊断:  
                                  <span>{{innerItem.disease_course}};</span>                            
                                  <span>{{innerItem.diagnosis | formatConclusion}}</span>                              
                                </p>     
                                <p class="ellipsisP">
                                  病情:
                                  <span class="ellipsis ellipsisSpan">{{innerItem.curative_effect}}</span>
                                </p>       


                                <!-- <p>
                                  入院时间:
                                  <span>{{innerItem.inpat_date}}</span>
                                </p>
                                <p>
                                  出院时间:
                                  <span>{{innerItem.outpat_date}}</span>
                                </p>
                                <p class="ellipsisP">
                                  诊断:
                                  <span
                                    class="ellipsisSpan ellipsis"
                                  >{{innerItem.diagnosis | formatConclusion}}</span>
                                </p> -->
                                <template>
                                  <div
                                    style="display: flex;align-items: flex-end;justify-content: space-between"
                                  >
                                    <p class="ellipsisP">
                                      备注:
                                      <span
                                        class="ellipsis ellipsisSpan"
                                      >{{innerItem.remarks}}</span>
                                    </p>
                                    <!-- <div
                                      class="iconfont"
                                      v-acl="['inhospital_order']"
                                      style="font-size: 16px;margin-left: 10px;color: #f40;font-weight: bold"
                                      title="编辑住院信息"
                                      @click.stop="getInHospital(innerItem.id,item)"
                                      v-if="innerItem.isedit === 1"
                                    >&#xe630e;</div>
                                    <div
                                      class="iconfont"
                                      v-acl="['inhospital_order']"
                                      style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                      title="不可编辑"
                                      @click.stop=""
                                      v-else
                                    >&#xe630e;</div> -->
                                  </div>
                                </template>
                              </div>
                            </div>
                            <div
                              @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                              v-if="innerItem.typeDignoses=='手术'"
                              class="check-box2 operation"
                            >
                              <div
                                class="imgBack cardImg"
                                :style="`background-image: url(${operationDoctor})`"
                                style="background-size: contain;background-position: center center;background-repeat:  no-repeat;background-color: rgb(246,246,246)"
                              ></div>
                              <div class="check-info">
                                <p>
                                  手术时间:
                                  <span>{{innerItem.operation_date | formatTime1}}</span>
                                </p>
                                <p>
                                  手术名称:
                                  <span>{{innerItem.operation_name}}</span>
                                </p>
                                <p class="ellipsisP">
                                  手术部位:
                                  <span
                                    class="ellipsisSpan ellipsis"
                                  >&nbsp{{innerItem.operation_position}}</span>
                                </p>
                                <template v-if="innerItem.doctor_conclusion">
                                  <div
                                    style="display: flex;align-items: flex-end;justify-content: space-between"
                                  >
                                    <p class="ellipsisP">
                                      手术医生:
                                      <span
                                        class="ellipsis ellipsisSpan"
                                      >&nbsp{{innerItem.operation_doctor}}</span>
                                    </p>
                                    <!-- <div
                                      v-acl="['operation_order']"
                                      class="iconfont"
                                      style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                      title="编辑手术信息"
                                      @click.stop="getOperationl(innerItem,item)"
                                      v-if="innerItem.isedit === 1"
                                    >&#xe630e;</div>
                                    <div
                                      v-acl="['operation_order']"
                                      class="iconfont"
                                      style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                      title="编辑手术信息"
                                      @click.stop=""
                                      v-else
                                    >&#xe630e;</div> -->
                                  </div>
                                </template>
                                <template v-else>
                                  <div
                                    style="display: flex;align-items: flex-end;justify-content: space-between"
                                  >
                                    <p>
                                      诊断结果:
                                      <span
                                        :title="innerItem.relevant_info[0].diagnosis | formatConclusion"
                                      >{{innerItem.relevant_info[0].diagnosis | formatConclusion}}</span>
                                    </p>
                                    <div
                                      v-acl="['operation_order']"
                                      class="iconfont"
                                      style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                      title="编辑手术信息"
                                      @click.stop="getOperationl(innerItem,item)"
                                      v-if="innerItem.isedit === 1"
                                    >&#xe630e;</div>
                                    <div
                                      v-acl="['operation_order']"
                                      class="iconfont"
                                      style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                      title="编辑手术信息"
                                      @click.stop=""
                                      v-else
                                    >&#xe630e;</div>
                                  </div>
                                </template>
                              </div>
                            </div>
                            <div
                              @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                              class="check-box2 inHospitalCard"
                              v-if="innerItem.typeDignoses=='白癜风基础'"
                            >
                              <div class="imgBack cardImg">
                                <!-- <template v-if="ele.image_hospitalization.length > 0">
                                  <img
                                    :src="hospitalization_imagesThumbnails
                                +ele.image_hospitalization[ele.image_hospitalization.length - 1].path"
                                    alt
                                    class="checkBoxImg"
                                    :class="{'heightAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width<ele.image_hospitalization[ele.image_hospitalization.length - 1].height,'widthAuto':ele.image_hospitalization[ele.image_hospitalization.length - 1].width>=ele.image_hospitalization[ele.image_hospitalization.length - 1].height}"
                                  />
                                </template> -->
                              </div>
                              <div class="check-info">
                                <p>
                                  记录时间:
                                  <span>{{innerItem.visit_date}}</span>
                                </p>
                                <p>
                                  类型及病程:  
                                  <span>{{innerItem.vitiligo_type}};</span>                            
                                  <span>{{innerItem.duration_months}}</span>                              
                                </p>     
                                <p class="ellipsisP">
                                  现部位:
                                  <span class="ellipsis ellipsisSpan">{{innerItem.current_location}}</span>
                                </p>                      
                                <p class="ellipsisP">
                                  BAS评分:
                                  <span>{{innerItem.bsa_score}}</span>
                                </p>
                                <p class="ellipsisP">
                                  用药:
                                  <span>{{innerItem.topical_medication}}</span>
                                </p>

                                <template>
                                  <div
                                    style="display: flex;align-items: flex-end;justify-content: space-between"
                                  >
                                    <p class="ellipsisP">
                                      备注:
                                      <span class="ellipsis ellipsisSpan">{{innerItem.remark1}}|{{innerItem.remark2}}|{{innerItem.remark3}}</span>
                                    </p>
                                    <div
                                      class="iconfont"
                                      v-acl="['sd_vitiligo']"
                                      style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                      title="编辑信息"
                                      @click.stop="getVitiligo(innerItem.id,item)"
                                      v-if="innerItem.isedit === 1"
                                    >&#xe630e;</div>
                                    <div
                                      class="iconfont"
                                      v-acl="['sd_vitiligo']"
                                      style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                      title="不可编辑"
                                      @click.stop=""
                                      v-else
                                    >&#xe630e;</div>
                                  </div>
                                </template>
                              </div>
                            </div>
                            <div
                              @click="getInfo(innerItem.id,item.id,innerItem.typeDignoses)"
                              class="check-box2 inHospitalCard"
                              v-if="innerItem.typeDignoses=='黑色素瘤'"
                            >
                              <div class="imgBack cardImg">
                              </div>
                              <div class="check-info">
                                <p>
                                  记录时间:
                                  <span>{{innerItem.visit_date}}</span>
                                  <span v-if="innerItem.baseline===1" class="baseline-badge">基线</span>
                                </p>
                                <p class="ellipsisP">
                                  原发部位:
                                  <span class="ellipsis ellipsisSpan">{{innerItem.primary_site}}</span>
                                </p>
                                <p class="ellipsisP">
                                  AJCC8分期:
                                  <span>{{innerItem.ajcc8_clinical_stage}}</span>
                                </p>
                                <p class="ellipsisP">
                                  手术方式:
                                  <span class="ellipsis ellipsisSpan">{{innerItem.method_of_first_surgery}}</span>
                                </p>
                                <template>
                                  <div
                                    style="display: flex;align-items: flex-end;justify-content: flex-end"
                                  >
                                    <!-- v-if="innerItem.isedit === 1" 点击进入对话框，但是会根据isedit状态判断是否可编辑 -->
                                    <div
                                      class="iconfont"
                                      v-acl="['sd_mm']"
                                      style="font-size: 16px;padding-left: 10px;color: #f40;font-weight: bold"
                                      title="编辑信息"
                                      @click.stop="getMm(innerItem.id, innerItem.isedit===1, item)"
                                      
                                    >&#xe630e;</div>
                                    <!-- <div
                                      class="iconfont"
                                      v-acl="['sd_mm']"
                                      style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                                      title="不可编辑"
                                      @click.stop=""
                                      v-else
                                    >&#xe630e;</div> -->
                                  </div>
                                </template>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="waiting" class="noData">
                      <img src="../assets/loading.png" class="loadingWait" />
                    </div>
                    <div v-if="!waiting">
                      <template v-if="resultArr.length === 0">暂无诊断数据</template>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="this.currentPage"
                  :page-size="this.pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="this.pageTotal">
                </el-pagination>
              </ul>
              </div>
              <InHospitalDialog
                :openHospitalId="openHospitalId"
                :isShowInHospital="isShowInHospital"
                :toDialoPatientsData="toDialoPatientsData"
                :lastDiagnosisText="lastDiagnosisText"
                @setInHpspitalStatus="setInHpspitalStatus()"
                @refreshHandler="refreshHandler"
              ></InHospitalDialog>
              <vitiligoBasicInfoDialog
                :openVitiligoId="openVitiligoId"
                :isShowVitiligo="isShowVitiligo"
                :toDialoPatientsData="toDialoPatientsData"
                :lastDiagnosisText="lastDiagnosisText"
                @setVitiligoStatus="setVitiligoStatus()"
                @refreshHandler="refreshHandler"
              ></vitiligoBasicInfoDialog>
              <MmBasicInfoDialog
                :openMmId="openMmId"
                :isShowMm="isShowMm"
                :toDialoPatientsData="toDialoMmPatientsData"
                @setMmStatus="setMmStatus($event)"
                @refreshHandler="refreshHandler"
                @refreshHandler1="refreshHandler1"
              ></MmBasicInfoDialog>

              <div class="resetPatients">
                <el-dialog
                  title="患者信息编辑"
                  class="dialog"
                  :visible.sync="reviseInfo"
                  width="714px"
                  :close-on-click-modal="false"
                  @close="reviseInfoClose"
                >
                  <div class="navBorder"></div>
                  <div id="addpaintent">
                    <el-form :model="form2" :rules="rules" ref="form22" inline>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">ID**</p>
                          <el-form-item prop="id_in_hospital" ref="id_in_hospital">
                            <el-autocomplete
                              v-model="form2.patientNumber"
                              :fetch-suggestions="querySearchPatientNumber"
                              :trigger-on-focus="false"
                              @select="selectPatientNumber"
                              type="text"
                              class="popInput"
                              :disabled="form2IdDisabled"
                              @input="form2.patientNumber = form2.patientNumber.replace(/[\u4e00-\u9fa5]/g, '')"
                            ></el-autocomplete>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">姓名**</p>
                          <el-form-item prop="name" ref="form2Name">
                            <el-input
                              v-model="form2.name"
                              maxlength="64"
                              type="text"
                              class="popInput"
                              @input="form2.name = form2.name.replace(/\d/g, '')"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-form>
                    <el-form :model="form2" :rules="rules" ref="form2" inline>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">出生日期*</p>
                          <el-form-item>
                            <el-date-picker
                              v-model="form2.birthday"
                              prefix-icon="iconfont icon-rili"
                              class="popInput"
                              align="right"
                              type="date"
                              default-value="1980-01-01"
                              :clearable="false"
                              value-format="yyyy-MM-dd"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">年龄*</p>
                          <el-form-item prop>
                            <el-input
                              class="popInput"
                              type="text"
                              v-model="form2.age"
                              placeholder
                              @input="form2.age =
                                form2.age.replace(/[^\d]/g, '')"
                              maxlength="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-form>
                    <el-form :model="form2" :rules="rules" ref="form2" inline>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">性别**</p>

                          <el-radio-group v-model="form2.gender" class="popInput isBW" size="medium">
                            <el-radio-button class="isBWItem" label="男"></el-radio-button>
                            <el-radio-button class="isBWItem" label="女"></el-radio-button>
                          </el-radio-group>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">手机号码</p>
                          <el-form-item prop ref="form2Phone">
                            <el-input
                              v-model="form2.phone"
                              type="text"
                              class="popInput"
                              maxlength="11"
                              @input="form2.phone = form2.phone.replace(/[^\d]/g, '')"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-form>
                    <el-form :model="form2" :rules="rules" ref="form2" inline>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">身份证</p>
                          <el-form-item prop ref="form2Id_card_number">
                            <el-input
                              v-model="form2.id_card_number"
                              class="popInput"
                              type="text"
                              maxlength="18"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">籍贯</p>
                          <el-form-item prop>
                            <el-input v-model="form2.native_place" type="text" class="popInput"></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">民族</p>
                          <el-form-item prop ref="form2Race">
                            <el-input v-model="form2.race" type="text" class="popInput"></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">皮肤类型</p>
                          <el-form-item id="raceType-select" prop>
                            <el-select
                              v-model="form2.skin_type"
                              placeholder
                              size
                              class="popInput"
                              :disabled="readonly"
                            >
                              <el-option
                                v-for="item in skinOpsType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">电子邮箱</p>
                          <el-form-item prop>
                            <el-input v-model="form2.email" type="text" class="popInput"></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">国别</p>
                          <el-form-item prop>
                            <el-input v-model="form2.country" type="text" class="popInput"></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">肤色</p>
                          <el-form-item id="race-select" prop>
                            <el-select
                              v-model="form2.skin_color"
                              placeholder
                              size
                              class="popInput"
                              :disabled="readonly"
                            >
                              <el-option
                                v-for="item in skinOps"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="24">
                        <div class="leftItem">
                          <p class="rightItemTitle popTitleDialog">地址</p>
                          <el-form-item prop>
                            <el-input
                              :readonly="readonly"
                              v-model="form2.address"
                              type="text"
                              class="popInput popInputSingle2"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-form>
                  </div>
                </el-dialog>
              </div>

              <div v-if="showInfo" class="detailed-info"></div>
            
            <div class="mask" v-if="resiltsVisible" @click="closeResult"></div>
            <transition name="fade">
              <div v-if="resiltsVisible" class="resilts">
                <el-button
                  @click="closeResult"
                  style="position: absolute;right: 5.6rem;top: 2.5rem;z-index:999;"
                  type="primary"
                  icon="el-icon-close"
                  circle
                ></el-button>
                <DetailedResults
                  :wordbook="wordbook"
                  :detail_result="detail_result"
                  :imgList="imgList3"
                  v-on:compare="compare"
                />
              </div>
            </transition>
        
          </div>          

        </div>
      </div>
    </div>

    <!-- <div class="main-right">
      <div class="top-content">
        <div class="cohort-detail-wrapper">
          <div class="title">
            <div style="display: flex;align-items: center;">
              <i class="title-icon iconfont icon-iconset0194"></i>
              <span class="title-label">队列详情</span>
            </div>
          </div>
        </div>
      </div> 
      <div class="bottom-content">
        <div class="cohort-detail-wrapper">
          <div class="title">
            <div style="display: flex;align-items: center;">
              <i class="title-icon iconfont icon-iconset0194"></i>
              <span class="title-label">待定</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="mask" v-if="isTakePhone" @keydown="keydownTakePicture" tabindex="-1"></div> -->


    <!-- <el-dialog
      :visible.sync="showLargeImage"
      center
      custom-class="similarDialog showBigImage_dialog"
      modal
      top="0"
      :fullscreen="true"
      :before-close="closeShowLargeImage"
      v-if="showLargeImage"
    >
      <div
        style="position: absolute;left: 20px;right: 20px;top: 45px;bottom:20px;display: flex;align-items: center"
      >
        <CompareImage
          :primevalImage="primevalImage"
          :compareImageList="compareImageList"
          :isCompareImage="isCompareImage"
          :largeImgage="largeImgage"
          :largeImgage2="largeImgage2"
          :imageCompileClass="imageCompileClass"
          :imageCompileClass2="imageCompileClass2"
          :selected="selected"
          :selected2="selected2"
          :activeImage="activeImage"
          :activeImage2="activeImage2"
          @imageClick="imageClick"
          @imageDblclick="imageDblclick"
          @imageOnload="imageOnload"
          @checkImageCompile="checkImageCompile"
        ></CompareImage>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>

import gql from "graphql-tag";
// 涉及多维数据筛选的功能函数以及队列相关功能函数放在 cohort.js  中实现，降低代码复杂度。
import cohort from '../utils/cohort.js'
// 涉及患者列表相关功能函数放在 cohortPatientList.js 中实现，降低代码复杂度。基本上与PatientList.vue 页面功能保持一致，略作精简。
import cohortPatientList from '../utils/cohortPatientList.js'
import popMixins from "../utils/popMixins.js";
import CohortFilterGroup from './CohortFilterGroup.vue';
export default {
  components: {
    CohortFilterGroup
    // CommonHairdressingDigest,
    // CompareImage,
  },

  mixins: [cohort, cohortPatientList, popMixins],

  // provide() {
  //   return {
  //     commonData: this.commonData,
  //     refreshPage: this.refreshPage,
  //     selectedImage: this.selectedImage,
  //     unSelectedImage: this.unSelectedImage,
  //     getImageInfo: this.getImageInfo,
  //     getHairdressingTree: this.getHairdressingTree
  //   };
  // },

  data() {
    return {

    };
  },
  methods: {
  },

  async mounted() {    
  },

  async created() {
  }
};

</script>

<style lang="less">
.resetPatients {
  .el-dialog__title {
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-input__inner {
    border-radius: 8px;
    height: 46px;
    color: #6b6b6b;
    font-size: 18px;
  }
  .el-input__prefix {
    left: 250px;
    i {
      font-size: 35px !important;
      color: #797979;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  .el-input__icon {
    line-height: 46px;
  }
  .el-input__suffix-inner {
    i {
      font-size: 30px !important;
      color: #797979 !important;
    }
  }
  .el-input__suffix {
    right: 10px !important;
  }
  .el-button--primary {
    border-radius: 6px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-radio-button__inner {
    width: 100%;
    height: 46px;
    border-radius: 8px;
    line-height: 23px;
    font-size: 20px;
    font-weight: 600;
  }
}
</style>

<style lang="less" scoped>
.page-container {
  display: flex;
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .main-left {
    display: flex;
    flex-direction: column;
    width: 450px;
    padding: 5px 0 5px 6px;
    background-color: #eff2f7;
    overflow-y: auto;

    .top-content {
      height: 600px;
      min-height: 600px;
      overflow-y: auto;
    }

    .bottom-content {
      flex: 1;
      min-height: 190px;
      overflow-y: auto;
    }
  }

  .main-center {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    .top-content {
      height: 450px;
      min-height: 450px;
      padding: 0 10px;
      margin-bottom: 5px;
      overflow-y: auto;
    }
    .bottom-content {
      flex: 1;
      padding: 0 10px;
      overflow-y: auto;
    }
  }

  // .main-right {
  //   width: 330px;
  //   background-color: #eff2f7;
  // }
  .main-right {
    display: flex;
    flex-direction: column;
    width: 330px;
    // padding: 5px 0 5px 6px;
    background-color: #eff2f7;
    overflow-y: auto;

    .top-content {
      height: 600px;
      min-height: 600px;
      overflow-y: auto;
    }

    .bottom-content {
      flex: 1;
      min-height: 190px;
      overflow-y: auto;
    }
  }

}

.filter-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #48a3c2;
    font-size: 16px;
    border-bottom: 1px solid #48a3c2;
    padding: 5px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    height: 30px;
    text-align: left;
    align-items: center;
    .title-icon{
      font-size:24px;
      margin-right:10px;
    }
    .title-label{
      white-space: nowrap;
      font-size: 18px;
    }
  }
  .content{
    flex: 1;
    overflow-y: auto;

    .cohort-list-toolbar {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      gap: 8px;
    }

    .cohort-name-link {
      color: #409eff;
      cursor: pointer;
      &:hover { text-decoration: underline; }
    }

    .cohort-list-pagination {
      margin-top: 8px;
      text-align: center;
      .el-pagination { padding: 0; }
    }

    /deep/ .el-table .cohort-row-selected {
      background-color: #d0e8f0 !important;
      td { background-color: #d0e8f0 !important; }
    }
  }
}

.diagnosis-form-wrapper{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .title {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 30px);
    color: #48a3c2;
    font-size: 16px;
    border-bottom: 2px solid #48a3c2;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    height: 25px;
    text-align: left;
    align-items: center;
    .title-icon{
      font-size:24px;
      margin-right:10px;
    }
    .title-label{
      white-space: nowrap;
      font-size: 18px;
    }
  }
  .content{
    flex: 1;
    overflow-y: auto;
    padding-right: 7%;
    text-align: right;
    height: 50%;
  }
  .dialog-box{
    display: flex;
    align-items: center;
    .label{
      width: 80px;
      font-weight: bold;
    }
    .input-box{
      flex: 1;
    }
  }
  .number-of-treatment{
    flex: 1;
    margin-right: 2%;
    height: 28px;
    color: rgb(96,98,102);
    box-sizing: border-box;
    background-color: rgb(245,247,250);
    border: 1px solid rgb(228,231,237);
    text-align: left;
    text-indent: 15px;
    user-select: none;
  }
}

.cohort-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 4px;
  box-sizing: border-box;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #48a3c2;
    font-size: 16px;
    border-bottom: 1px solid #48a3c2;
    background-color: #fff;
    padding: 5px;
    padding-bottom: 10px;
    overflow: hidden;
    height: 30px;
    text-align: left;
    .btn-wrap {
      display: flex;
      .radio-wrap {
        display: flex;
        align-items: center;
        margin-right: 10px;
        font-size: 14px;
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    box-shadow: 0 2px 3px #909090;
    background-color: #eff2f7;
    padding: 10px;
    overflow: hidden;
    .image-item {
      width: 293px;
      height: 320px;
      padding: 5px 3px;
      .image-box {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 3px;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px 1px #c0c0c0;
        background-color: #ffffff;
        .image {
          height: 290px;
          overflow: hidden;
          position: relative;
          .mapShade {
            position: absolute;
            width: 20px;
            height: 20px;
            top: 0;
            left: 0;
          }
          .noClick {
            position: absolute;
            user-select: none;
            opacity: 0;
          }
        }
        .image-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 24px;
          .status {
            padding-left: 10px;
            font-weight: bold;
            font-size: 15px;
          }
          .time {
            padding-right: 10px;
            font-weight: bold;
            font-size: 15px;
          }
        }
        .afloat-menu {
          display: none;
          position: absolute;
          left: 0;
          top: 0;
          margin-top: 5px;
          margin-left: 5px;
          .menu-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 40px;
            background-color: #ebebeb;
            border-radius: 5px;
            background-color: rgba(240, 240, 240, 0.7);
            cursor: pointer;
            user-select: none;
            .screen-icon {
              color: #1296db;
              font-size: 26px;
            }
            .delete-icon {
              width: 30px;
              height: 30px;
            }
            .love-icon {
              width: 32px;
              height: 32px;
            }
          }
          .menu-btn + .menu-btn {
            margin-left: 2px;
          }
        }
      }
      .image-box:hover .afloat-menu {
        display: flex;
      }
      .image-box.active {
        background-color: rgb(97, 162, 191);
      }
      .image-box.active .image-title {
        color: #ffffff;
      }
    }
  }
}

.cohort-wrapper .el-radio-button__inner {
  width: 80px;
  font-size: 14px;
}

// ====== 多维筛选区样式 ======

.filter-container {
  display: flex;
  gap: 10px;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.field-dictionary {
  width: 200px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  padding: 8px;
  overflow-y: auto;
  min-height: 0;

  .dict-groups {
    .dict-group {
      margin-bottom: 8px;
      .dict-group-title {
        font-size: 13px;
        font-weight: 600;
        color: #303133;
        padding: 4px 0;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 2px;
        i { margin-right: 4px; color: #909399; }
      }
      .dict-field-item {
        font-size: 12px;
        color: #606266;
        padding: 3px 6px;
        cursor: pointer;
        border-radius: 3px;
        transition: background 0.2s;
        i { margin-right: 4px; color: #c0c4cc; }
        &:hover {
          background: #ecf5ff;
          color: #409eff;
          i { color: #409eff; }
        }
      }
    }
  }
}

.query-builder {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .query-builder-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    background: #fafafa;
  }

  .filter-actions {
    margin-top: 8px;
    padding-top: 6px;
    border-top: 1px solid #ebeef5;
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }
}

.preview-count {
  margin-left: 15px;
  font-size: 13px;
  color: #909399;
  b {
    color: #409eff;
    font-size: 16px;
  }
  .preview-view-btn {
    margin-left: 8px;
    padding: 0;
    font-size: 13px;
  }
}

.patient-list-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 20px;
  box-sizing: border-box;
  
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #48a3c2;
    font-size: 16px;
    border-bottom: 1px solid #48a3c2;
    background-color: #fff;
    padding: 5px;
    padding-bottom: 10px;
    overflow: hidden;
    height: 30px;
    text-align: left;
    
    .btn-wrap {
      display: flex;
    }
  }
  .parameter-number{
    display: flex;
    align-items: center;
    height: 46px;
    padding: 0 17px 0 20px;
    background-color: rgb(159,201,224);
    box-shadow: 0 2px 3px #909090;
    .text{
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 15px;
    }
    .numbers-content{
      display: flex;
      flex: 1;
      height: 100%;
      overflow: hidden;
      .numbers-box{
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        padding-left: 28px;
        padding-right: 5px;
        .to-left-btn{
          position: absolute;
          left: 5px;
          top: 0;
          width: 20px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          cursor: pointer;
          user-select: none;
        }
        .to-left-btn:active{
          color: rgb(187, 187, 187);
        }
        .to-right-btn{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: 100%;
          color: #ffffff;
          margin-right: 6px;
          cursor: pointer;
          user-select: none;
        }
        .to-right-btn:active{
          color: rgb(187, 187, 187);
        }
        .num-item-wrap{
          position: relative;
          height: 100%;
          .num-item-box{
            display: flex;
            align-items: center;
            height: 100%;
            .num-item{
              display: flex;
              justify-content: center;
              align-items: center;
              width: 28px;
              height: 28px;
              background-color: rgb(235,235,235);
              border-radius: 5px;
              border: 1px solid rgb(72, 151, 199);
              box-sizing: border-box;
              cursor: pointer;
              user-select: none;
            }
            .num-item + .num-item{
              margin-left: 6px;
            }
            .num-item:last-child{
              margin-right: 3px;
            }
            .num-item.active{
              cursor: default;
              color: #ffffff;
              transform: scale(1.1);
              background-color: #f00;
            }
          }
        }
        .add-btn{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 28px;
          height: 28px;
          color: #ffffff;
          background-color: #e9af3f;
          border-radius: 5px;
          box-shadow: 2px 2px 3px #909090;
          cursor: pointer;
          user-select: none;
          font-size: 20px;
          font-weight: normal;
        }
      }
      .numbers-box.showSlide{
        flex: 1;
        overflow: hidden;
        .num-item-wrap{
          flex: 1;
          overflow: hidden;
          .num-item-box{
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
  }
  .type-tab-wrap{
    position: relative;
    height: 44px;
    .type-tab{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      display: flex;
      height: 44px;
      background-color: #fff;
      .slide-btn{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        box-sizing: border-box;
        color: #9FC8E3;
        background-color: #F1F2F8;
        /*border-left: 1px solid #9FC8E3;*/
        /*border-right: 1px solid #9FC8E3;*/
        border-bottom: 1px solid #e0e0e0;
        user-select: none;
      }
      .slide-btn:active{
        color: #fff;
        background-color: #e4ecf8;
      }
      .center-box{
        position: relative;
        flex: 1;
        overflow: hidden;
        .tab-content{
          position: absolute;
          top: 0;
          display: flex;
          height: 100%;
          width: max-content;
          .tab-item{
            float: left;
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 130px;
            height: 100%;
            padding: 0 15px;
            box-sizing: border-box;
            background-color: #EBEBEB;
            border-bottom: 1px solid #e0e0e0;
            user-select: none;
            cursor: pointer;
          }
          .tab-item + .tab-item{
            border-left: 2px solid #ccc;
          }
          .tab-item.active{
            background-color: #EFF2F7;
            border-bottom-color: #EFF2F7;
          }
          .tab-item.disabled{
            cursor: default;
          }
        }
      }
    }
    .type-tab.on{
      z-index: 1;
    }
  }
  
  .content {
    display: flex;
    flex: 1;
    width: 100%;
    // box-shadow: 0 4px 3px #909090;
    background-color: #EFF2F7;
    // padding: 15px 10px;
    overflow-y: auto;
  }

  .quickSearch {
    width: 100%;
    height: 40px;
    flex-direction: column;
    align-items: flex-start;
    // border: 1px solid #61a2bf;
    // padding: 10px;
    font-size: 16px;
    // color: #61a2bf;
    background-color: #EFF2F7;
    border-radius: 6px;
    margin-top: 6px;
    margin-bottom: 6px;
    // margin-right: 1%;
    
    .quickSearchLine {
      width: 60%;
      display: flex;
      flex-direction: row;
      align-items: center;
      
      .inline-input {
        ::-webkit-input-placeholder {
          text-align: center;
        }
      }
    }
  }
}


.cohort-detail-wrapper{
  height: 100%;
  padding: 0 5px;
  .title {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    color: #48a3c2;
    font-size: 16px;
    border-bottom: 1px solid #48a3c2;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    height: 25px;
    text-align: left;
    align-items: center;
    .title-icon{
      font-size:24px;
      margin-right:10px;
    }
    .title-label{
      white-space: nowrap;
      font-size: 18px;
    }
  }
}

.mask {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
}


// 以下用于PatientList，来源于PatientList.vue，后续会抽离成单独组件 ///////////////////////////////////////////

@import "../css/scroll.less";
@import "../assets/style/style.less";

@keyframes loading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.loadingWait {
  animation: loading 1.5s linear infinite;
  width: 24px;
  height: auto;
}

.imgWrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.similarDialog {
  .imgWrapper {
    align-items: flex-start;
    justify-content: space-between;
    font-size: 1.5rem;
    margin-top: 10vh;
    color: #48a3c2;
    padding-bottom: 30px;

    .chooseImgCon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      text-align: center;
      margin-right: 2%;

      .cs-text {
        margin-bottom: 2vh;
      }

      .imgBack {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 654px;
        height: 500px;
      }
    }

    .chooseImgCon:nth-child(2) {
      margin-right: 0px;
    }
  }
}

.mask {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.resilts {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.formWrapper,
.headTitle,
.leftIcon,
.formTitle,
// .title,
.formItem {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.formWrapper {
  position: fixed;
  top: 10vh;
  left: 40%;
  width: 600px;
  height: 68%;
  border-radius: 10px;
  background: #ebebeb;

  .headTitle {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 17px;
    font-weight: bold;
    color: #61a2bf;
    width: 94%;
    margin-left: 3%;
    padding: 5px 0%;
    border-bottom: 2px solid #61a2bf;

    .leftIcon {
      flex-direction: row;
      align-items: center;
      white-space: nowrap;
      margin-left: 2%;
    }
  }

  .formTitle {
    width: 84%;
    padding: 10px 8%;

    .title {
      width: 100%;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
    }

    .formItem {
      width: 100%;
      flex-direction: row;
      justify-content: flex-start;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.inline-label {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  padding: 1% 1%;
  font-weight: 600;

  .name {
    width: 68px;
    margin-right: 44%;
  }
}

.phoneCon {
  display: flex;
  flex-direction: row;
  margin-left: 1%;
  font-weight: 600;
}

.idAndname {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  font-size: 20px;
  font-weight: 600;
  color: #000;

  .namecon {
    margin-right: 12vh;
    margin-bottom: 2vh;
  }

  .idcon {
    margin-bottom: 2vh;
  }
}

.confirm {
  width: 100%;
  height: 10%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  .comfirmBtn {
    cursor: pointer;
    width: 200px;
    height: 40px;
    border-radius: 10px;
    background: #61a2bf;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
  }
}
ul,
p {
  list-style: none;
  margin: 0;
  padding: 0;
}

.content {
  width: 100%;
  margin: 0 auto;
  position: relative;
  height: calc(~"100% - 50px");
}

.header {
  padding: 10px 2%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-shrink: 0;
  position: relative;
}

.patient-list {
  background: #fff;
  margin-left: 10px;
  margin-right: 10px;
  height: calc(~"100% - 60px");
}

.patient-list .list-header,
.list-content .list-item {
  display: flex;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #ebebeb;
}

.patient-list span {
  text-align: center;
}

.list-header {
  color: #4aa3c4;
}

.noData {
  height: 160px;
  width: 100%;
  line-height: 120px;
  text-align: center;
  font-size: 24px;
  border-bottom: 1px solid #ebebeb;
  padding: 20px 40px;
  overflow: hidden;
  box-sizing: border-box;
}

.list-hid {
  width: 100%;
  padding: 20px 10px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.swiper-slide {
  display: flex;
}

.firstShow {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}
.cardImg {
  overflow: hidden;
  width: 110px !important;
  min-width: 110px !important;
  height: 110px !important;
}
.moreShow {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.check-box {
  cursor: pointer;
  width: 22%;
  // min-width: 412px;
  height: 100%;
  background: #ebebeb;
  border-radius: 20px;
  box-shadow: 5px 5px 5px #888888;
  float: left;
  margin: 10px 1.16%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;

  .card-type-badge {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    z-index: 10;
    pointer-events: none;
  }

  .imgBack {
    width: 155px;
    height: 115px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .check-info {
    span {
      color: black;
    }
  }
}

.moreItem {
  width: 100%;
  margin-top: 1%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.getMore {
  margin-top: 20px;
  cursor: pointer;
  text-align: center;
  color: #4aa3c4;
  font-size: 15px;
}

.check-box .check-img {
  width: 120px;
  height: 93px;
  float: left;
  margin-right: 10px;
}

.checkBoxImg {
  width: 35%;
  height: auto;
}

.check-box .check-info {
  margin-left: 5%;
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.check-info p {
  color: #4aa3c4;
  margin-bottom: 3px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
  font-size: 14px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dialog-footer {
  text-align: right;
}

.detailed-info {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.el-dialog__wrapper::-webkit-scrollbar {
  display: none;
}

/*!*分页按钮*!
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;

  .current-page {
    color: @sColor;
    height: 40px;
    line-height: 40px;
    margin: 0 20px;
  }
}*/

.list-wrapper {
  // position: absolute;
  // left: 0;
  // top: 50px;
  // right: 0;
  // bottom: 0;
  // background-color: #ebebeb;
}

.el-collapse {
  height: calc(~"100% - 51px");
  overflow-y: auto;
}
.ellipsisP {
  flex: 1;
  display: flex;
  .ellipsisSpan {
    flex: 1;
    width: 1px;
    text-align: left;
  }
}
.space {
  flex: 1;
}
.createPatients {
  height: 36px;
}
.dialog {
  // min-width: 1205px;
  display: flex;
  align-items: center;
  .navBorder {
    width: 100%;
    height: 2px;
    background: #4da3c0;
  }
  .popTitleDialog {
    font-size: 20px;
    font-weight: 600;
    color: black;
    margin-bottom: 15px;
    margin-top: 15px;
    text-indent: 12px;
  }
  .popInput {
    width: 294px;
    border: 1px solid #c0c0c0 !important;
    border-radius: 8px;
    height: 48px;
    box-sizing: border-box;
  }
  .popInputSingle2 {
    width: 630px !important;
  }
  .leftItemSubmit2 {
    width: 298px;
    height: 42px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .isBW {
    display: flex;

    .isBWItem {
      flex: 1;
      font-size: 20px !important;
      font-weight: 600;
    }
    .activeBW {
      background: white;
      color: black;
    }
  }
}
#addpaintent {
  // display: flex;
  padding: 0 15px;
  box-sizing: border-box;
}
.heightAuto {
  width: 110px;
  height: auto;
}
.widthAuto {
  width: auto;
  height: 110px;
}
.check-box2 {
  width: 100%;
  display: flex;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.inHospitalCard p {
  color: #c59d69;
}
.baseline-badge {
  display: inline-block;
  background: #13ce66;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 10px;
  margin-left: 6px;
  vertical-align: middle;
  letter-spacing: 1px;
}
.operation p {
  color: rgb(39, 101, 59);
}
.cosmetology {
  color: rgb(168, 66, 109) !important;
}
.tableTitle {
  cursor: pointer;
}

  .modify-btn:hover{
    color: #ff7979 !important;
  }
.el-pagination{
  text-align:-webkit-center;
  text-align:center;
  padding-top: 12px;
  padding-bottom: 8px;
  background-color: #fff;
}
.no_print{
  color: rgb(255,68,0);
}

.no_phone{
  color: rgb(255,68,0);
}
.online_report_regular{
  color: rgb(59, 212, 125);  
}
.online_report_note{
  color: rgb(90, 103, 247);  
}
.online_report_error{
  color: rgb(255, 27, 84)  
}
// 以上用于PatientList，来源于PatientList.vue，后续会抽离成单独组件 ///////////////////////////////////////////

// 队列详情区域
.cohort-detail-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
}
.cohort-detail-info {
  padding: 8px 12px;
}
.cohort-detail-row {
  display: flex;
  align-items: flex-start;
  padding: 6px 0;
  border-bottom: 1px dashed #ebeef5;
  &:last-child {
    border-bottom: none;
  }
}
.cohort-detail-label {
  flex-shrink: 0;
  width: 70px;
  font-size: 13px;
  color: #909399;
  line-height: 22px;
}
.cohort-detail-value {
  flex: 1;
  font-size: 13px;
  color: #303133;
  line-height: 22px;
  word-break: break-all;
}
.cohort-detail-desc {
  color: #606266;
  white-space: pre-wrap;
}

.btn-white{
    background: #ffffff;
    color: #333333;
    border: 1px solid #61a2bf;
    padding: 5px 10px;
    border-radius: 5px;
    width: 150px;
    height: 30px;
    box-shadow: 0px 0px 0px grey;
}
</style>
